<template>
    <v-dialog max-width="800" :value="value" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="text-h5 mb-3"
            >
                Setup Iniziale
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.native="$emit('input', false)">
                        <v-icon color="info">mdi-close</v-icon>
                    </v-btn>
                    </template>
                    <span>Esci</span>
                </v-tooltip>                 
            </v-card-title>
            <v-carousel
            cycle
            height="400"
            hide-delimiter-background
            show-arrows-on-hover
            >
                <v-carousel-item
                    v-for="(slide, i) in slides"
                    :key="i"
                >
                    <v-sheet
                    :color="colors[i]"
                    height="100%"
                    >
                    <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                    >
                        <div class="text-h2">
                        {{ slide }} Slide
                        </div>
                    </v-row>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
            <!--
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.native="$emit('input', false)">
                <v-icon>mdi-thumb-up</v-icon>
                </v-btn>
            </v-card-actions>
            -->
        </v-card> 
    </v-dialog>   
</template>
<script>
export default {
    props:['value'],
      data () {
    return {
      dialog:false,
      colors: [
        'indigo',
        'warning',
        'pink darken-2',
        'red lighten-1',
        'deep-purple accent-4',
      ],
      slides: [
        'Tabelle',
        'Tavoli',
        'Impostazioni',
        'Eccezioni',
        'Altro',
      ],
    }},
    methods:
    {

    } 
}
</script>